module.exports = __webpack_public_path__ + "static/close-black.e0f7aae6.svg";